import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { boxInvitationsQuery } from 'networking/mindfeed/queries/boxInvitations';
import type { Invitation } from 'models/Invitation';
import { BoxId } from 'models/Box';

type QueryKeyType = [QueryKey.BOX_INVITATIONS, BoxId?];

type Options = Omit<
  UseQueryOptions<Invitation[], unknown, Invitation[], QueryKeyType>,
  'queryKey' | 'queryFn'
>;

type Params = {
  boxId?: BoxId;
  options?: Options;
};

export default function useBoxInvitations({
  boxId,
  options = {},
}: Params = {}) {
  // With no box id the query is defined but doesn't run.
  const query = useQuery({
    ...boxInvitationsQuery(boxId),
    placeholderData: (previousData) => previousData,
    ...options,
  });

  const canRun = !!boxId && (options?.enabled ?? true);

  return {
    ...query,
    isLoading: canRun && query.isPending,
  };
}
